import {Injectable} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {ToastrService} from 'ngx-toastr';
import {InformDialogComponent} from '../components/shared/notification/inform/inform-dialog.component';
import {ConfirmDTO} from '../components/shared/notification/ConfirmDTO';
import {ConfirmDialogComponent} from '../components/shared/notification/confirm/confirm-dialog.component';
import {InformDTO} from '../components/shared/notification/InformDTO';
import {Err} from '../err';

@Injectable({
  providedIn: 'root'
})

export class NotificationService {

  constructor(private dialog: MatDialog,
              private toastr: ToastrService) {
  }

  confirm(text: ConfirmDTO, width?: string): Promise<void> {
    return this.dialog.open(ConfirmDialogComponent, {data: text, width: width}).componentInstance.promise();
  }

  success(message?: string, title?: string) {
    this.toastr.success(message ?? 'Gelukt!', title);
  }

  warning(message?: string, title?: string) {
    this.toastr.warning(message, title);
  }

  error(message?: string, title?: string) {
    this.toastr.error(message, title);
  }

  inform(text: InformDTO): Promise<void> {
    return this.dialog.open(InformDialogComponent, {data: text}).componentInstance.promise();
  }

  errorResponse(response) {
    const error = Err[response.error.message];
    this.error(error ?? response.error.message);
  }

  unsavedChanged(unsavedChanges: boolean, save, callback) {
    if (unsavedChanges) {
      const text = {
        header: 'er zijn onopgeslagen wijzigingen',
        ok: 'wijzigingen opslaan'
      };
      this.confirm(text)
        .then(() =>  save().then(() => callback()));
    } else {
      callback();
    }
  }
}
